<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div
  [dir]="dir"
  [ngClass]="{
    minisidebar: minisidebar,
    boxed: boxed,
    danger: danger,
    blue: blue,
    green: green,
    dark: dark,
    ecarup: ecarup
  }"
  class="main-container"
>
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar class="topbar telative" color="primary">
    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header">
      <a class="navbar-brand" href="/dashboard">
        <!-- Logo icon -->
        <b>
          <!-- Light Logo icon -->
          <img
            alt="homepage"
            class="light-logo"
            src="assets/images/logo-light-icon-text.png"
          />
        </b>
        <!--End Logo icon -->
      </a>
    </div>
    <button (click)="snav.toggle()" mat-button value="sidebarclosed">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="topbar-right">
      <!-- Subscription Type Display -->
      <div *ngIf="licenseInfo" class="subscription-section">
        <span *ngIf="licenseInfo.tier === 'premium'" class="subscription-badge premium">
          {{ 'licenses.premium' | translate }}
        </span>

        <span *ngIf="licenseInfo.tier === 'gold-partner'" class="subscription-badge premium">
          {{ 'licenses.gold-partner' | translate }}
        </span>

        <div *ngIf="licenseInfo.tier === 'free'" class="subscription-link-style">
          <span class="status-text">{{ 'licenses.free' | translate }}</span>
          <a class="upgrade-action" routerLink="/account/licenses">
            {{ 'licenses.upgrade-now' | translate }}
          </a>
        </div>
      </div>


      <!-- Action Buttons Section -->
      <div class="action-buttons">
        <a [href]="getTranslatedNewsLink()" class="news-button" mat-button target="_blank">
          <div class="icon-container">
            <mat-icon>rocket</mat-icon>
            <span class="notification-dot"></span>
          </div>
          {{ 'sidemenu.news' | translate }}
        </a>
        <button (click)="end.toggle()" mat-button>
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container
    [ngClass]="{ minisidebar: minisidebar }"
    [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
    class="example-sidenav-container"
  >
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav
      #snav
      (close)="sidebarOpened = false"
      (open)="sidebarOpened = true"
      [disableClose]="mobileQuery.matches"
      [mode]="mobileQuery.matches ? 'side' : 'over'"
      [opened]="mobileQuery.matches"
      [perfectScrollbar]="config"
      class="pl-xs"
      fixedTopGap="0"
      id="snav"
    >
      <app-sidebar class="app-sidebar"></app-sidebar>
    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right Sidebar - style you can find in rightsidebar.component.scss -->
    <!-- ============================================================== -->
    <mat-sidenav
      #end
      class="chat-panel"
      mode="over"
      opened="false"
      position="end"
    >
      <div class="scroll">
        <mat-nav-list>
          <button (click)="authService.logout()" mat-menu-item>
            <mat-icon>power_settings_new</mat-icon>
            Logout
          </button>
          <h3 class="text-uppercase font-weight-bold" mat-subheader>
            {{ 'sidemenu.languages' | translate }}
          </h3>
          <button (click)="setLanguage('de')" mat-menu-item>
            <mat-icon>language</mat-icon>
            Deutsch
          </button>
          <button (click)="setLanguage('en')" mat-menu-item>
            <mat-icon>language</mat-icon>
            English
          </button>
          <button (click)="setLanguage('fr')" mat-menu-item>
            <mat-icon>language</mat-icon>
            Français
          </button>
          <button (click)="setLanguage('it')" mat-menu-item>
            <mat-icon>language</mat-icon>
            Italiano
          </button>
          <h3 class="text-uppercase font-weight-bold" mat-subheader>
            {{ 'sidemenu.settings' | translate }}
          </h3>
          <mat-list-item>
            <mat-slide-toggle [(ngModel)]="boxed" color="primary">{{
                'sidemenu.layout' | translate
              }}
            </mat-slide-toggle>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <router-outlet>
          <app-spinner></app-spinner>
        </router-outlet>
      </div>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
